module.exports = __webpack_public_path__ + "img/popup-double9.5d3de974.png";